/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Merge_Replace_HelpInputs */

const en_marker_import_merge_replace_help = /** @type {(inputs: Marker_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge - Add markers to existing group without deleting any other markers. Replace - Removes all markers in the existing marker group prior to import`)
};

const fr_marker_import_merge_replace_help = /** @type {(inputs: Marker_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner - Ajouter des marqueurs au groupe existant sans supprimer les autres marqueurs. Remplacer - Supprime tous les marqueurs du groupe existant avant l'importation`)
};

const de_marker_import_merge_replace_help = /** @type {(inputs: Marker_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführen – Fügt Marker zu einer bestehenden Gruppe hinzu, ohne andere Marker zu löschen. Ersetzen – Entfernt alle Marker in der bestehenden Markergruppe vor dem Import.`)
};

const it_marker_import_merge_replace_help = /** @type {(inputs: Marker_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci: aggiunge marcatori al gruppo esistente senza eliminarne altri. Sostituisci: rimuove tutti i marcatori nel gruppo di marcatori esistente prima dell'importazione.`)
};

const ru_marker_import_merge_replace_help = /** @type {(inputs: Marker_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединение — добавляет маркеры в существующую группу без удаления других маркеров. Замена — удаляет все маркеры из существующей группы перед импортом.`)
};

const es_marker_import_merge_replace_help = /** @type {(inputs: Marker_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar: Agrega marcadores al grupo existente sin eliminar los demás. Reemplazar: Elimina todos los marcadores del grupo existente antes de la importación.`)
};

const zh_cn2_marker_import_merge_replace_help = /** @type {(inputs: Marker_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并 - 将标记添加到现有组，而不删除任何其他标记。替换 - 在导入之前删除现有标记组中的所有标记。`)
};

const ja_marker_import_merge_replace_help = /** @type {(inputs: Marker_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結合 - 他のマーカーを削除せずに、既存のグループにマーカーを追加します。置換 - インポート前に既存のマーカーグループ内のすべてのマーカーを削除します。`)
};

const hi_marker_import_merge_replace_help = /** @type {(inputs: Marker_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मर्ज - अन्य मार्करों को हटाए बिना मौजूदा समूह में मार्कर जोड़ें। रिप्लेस - आयात से पहले मौजूदा मार्कर समूह में सभी मार्करों को हटाता है।`)
};

const pt_pt2_marker_import_merge_replace_help = /** @type {(inputs: Marker_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesclar - Adiciona marcadores a um grupo existente sem excluir nenhum outro marcador. Substituir - Remove todos os marcadores do grupo de marcadores existente antes da importação.`)
};

/**
* | output |
* | --- |
* | "Merge - Add markers to existing group without deleting any other markers. Replace - Removes all markers in the existing marker group prior to import" |
*
* @param {Marker_Import_Merge_Replace_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_merge_replace_help = /** @type {((inputs?: Marker_Import_Merge_Replace_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Merge_Replace_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_merge_replace_help(inputs)
	if (locale === "de") return de_marker_import_merge_replace_help(inputs)
	if (locale === "it") return it_marker_import_merge_replace_help(inputs)
	if (locale === "ru") return ru_marker_import_merge_replace_help(inputs)
	if (locale === "es") return es_marker_import_merge_replace_help(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_merge_replace_help(inputs)
	if (locale === "ja") return ja_marker_import_merge_replace_help(inputs)
	if (locale === "hi") return hi_marker_import_merge_replace_help(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_merge_replace_help(inputs)
	return en_marker_import_merge_replace_help(inputs)
});